(() => {
  if (window.ckJapanGalleryContinuation) {
    window.ckJapanGalleryContinuation();
    return;
  }
  const original = new WeakMap();
  const changed = new Set();
  const imageAttributes = ['src', 'srcset', 'data-src', 'data-srcset', 'alt'];
  let pending = false;

  function setAttribute(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function remember(node, attributes) {
    if (!original.has(node)) {
      original.set(node, Object.fromEntries(attributes.map(name => [name, node.getAttribute(name)])));
    }
    changed.add(node);
  }

  function apply() {
    pending = false;
    const active = new Set();
    document.querySelectorAll('[data-ck-jp-gallery-continuation][data-enabled="JP"] [data-ck-jp-slot]').forEach(block => {
      const position = Number(block.dataset.ckJpSlot) + 1;
      const slide = document.querySelector(`[data-casekoo-gallery-position="${position}"]`);
      if (!slide) return;
      if (block.hasAttribute('data-shopify-editor-block') && slide.firstElementChild) {
        const wrapper = slide.firstElementChild;
        remember(wrapper, ['data-ck-jp-editor-slot']);
        active.add(wrapper);
        setAttribute(wrapper, 'data-ck-jp-editor-slot', block.dataset.ckJpSlot);
      }
      const source = block.querySelector('template[data-ck-jp-replacement]')?.content.querySelector('img');
      if (!source) return;
      const mediaId = slide.dataset.mediaId;
      const thumbnails = document.querySelectorAll(`.product-thumbnail-list-item[data-media-id="${mediaId}"]`);
      const targets = [slide, ...thumbnails];
      targets.forEach(target => {
        target.querySelectorAll('img').forEach(img => {
          remember(img, imageAttributes);
          active.add(img);
          const src = source.getAttribute('src');
          const srcset = source.getAttribute('srcset');
          setAttribute(img, 'src', src);
          if (srcset) setAttribute(img, 'srcset', srcset);
          else img.removeAttribute('srcset');
          // The existing lazy loader must also read the replacement, never the old file.
          if (img.hasAttribute('data-src')) setAttribute(img, 'data-src', src);
          if (img.hasAttribute('data-srcset')) {
            if (srcset) setAttribute(img, 'data-srcset', srcset);
            else img.removeAttribute('data-srcset');
          }
          if (source.getAttribute('alt')) setAttribute(img, 'alt', source.getAttribute('alt'));
        });
      });
      thumbnails.forEach(thumbnail => {
        const link = thumbnail.querySelector('a.media-thumbnail');
        if (!link) return;
        remember(link, ['href']);
        active.add(link);
        setAttribute(link, 'href', source.getAttribute('src'));
      });
    });
    changed.forEach(node => {
      if (active.has(node)) return;
      if (node.isConnected) {
        Object.entries(original.get(node)).forEach(([name, value]) => {
          if (value === null) node.removeAttribute(name);
          else setAttribute(node, name, value);
        });
      }
      changed.delete(node);
      original.delete(node);
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(apply);
  }
  window.ckJapanGalleryContinuation = schedule;
  // The editor requires a block to remain inside its owning Shopify section.
  // In inspect mode only, align that real block's transparent hit area with its
  // gallery image. This preserves native hover labels and sidebar selection.
  let inspecting = Boolean(window.Shopify?.inspectMode);
  let inspectionFrame = 0;
  function syncInspector() {
    inspectionFrame = 0;
    document.querySelectorAll('[data-ck-jp-gallery-continuation]').forEach(container => {
      const enabled = inspecting && container.dataset.enabled === 'JP';
      container.hidden = !enabled;
      container.querySelectorAll('[data-ck-jp-slot]').forEach(block => {
        const position = Number(block.dataset.ckJpSlot) + 1;
        const slide = document.querySelector(`[data-casekoo-gallery-position="${position}"]`);
        const target = slide?.firstElementChild;
        const rect = target?.getBoundingClientRect();
        const show = enabled && rect?.width > 0 && rect?.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        const style = show
          ? `position:fixed;left:${rect.left}px;top:${rect.top}px;width:${rect.width}px;height:${rect.height}px;z-index:2147483000;pointer-events:auto;cursor:pointer;`
          : 'display:none;';
        setAttribute(block, 'style', style);
      });
    });
    if (inspecting) inspectionFrame = requestAnimationFrame(syncInspector);
  }
  document.addEventListener('shopify:inspector:activate', () => {
    inspecting = true;
    if (!inspectionFrame) syncInspector();
  });
  document.addEventListener('shopify:inspector:deactivate', () => {
    inspecting = false;
    if (inspectionFrame) cancelAnimationFrame(inspectionFrame);
    syncInspector();
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest('[data-ck-jp-slot], [data-ck-jp-editor-slot]');
    const blockId = event.detail?.blockId;
    const visibleBlock = block || [...document.querySelectorAll('[data-ck-jp-editor-slot]')].find(node => {
      try { return JSON.parse(node.getAttribute('data-shopify-editor-block') || '{}').id === blockId; }
      catch { return false; }
    });
    if (!visibleBlock) return;
    const position = Number(visibleBlock.dataset.ckJpSlot || visibleBlock.dataset.ckJpEditorSlot) + 1;
    const slide = document.querySelector(`[data-casekoo-gallery-position="${position}"]`);
    if (!slide) return;
    const thumbnail = document.querySelector(`.product-thumbnail-list-item[data-media-id="${slide.dataset.mediaId}"] a`);
    // Use the gallery's existing keyboard handler: a synthetic click would also
    // be intercepted by Shopify's active inspector and select Product instead.
    thumbnail?.dispatchEvent(new KeyboardEvent('keydown', { key: ' ', code: 'Space', bubbles: true, cancelable: true }));
    slide.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
  if (window.Shopify?.designMode) syncInspector();
})();
